
export class EventEmitterBo {
    isCreate: boolean = false;
    TimesheetId: string = "00000000-0000-0000-0000-000000000000";
    ClientList: any = [];
    

}



export class saveTimesheetBO {
    id: string | null;
    employeeId: string;
    clientId: string;
    clientAuthId: string;
    employee: string;
    client: string;
    service: string;
    serviceId: string;
    Day:string;
    hours: number;
    payRate: number;
    totalAmount: number;
    timesheetDate: string;
    timesheetNotes: string;
    eTimesheet: string | null;
    isTransportation : boolean | null;

}
export class TimesheetBO {
    authorizationId: string;
    employeeId: string;
    clientId: string;
    timesheets: saveTimesheetBO[];
}

export class DeletepermissionBO {
    timesheet_id: string;
    admin_Password: string;
}

export class recalculateBo{
    startDate:string;
    endDate:string;
    clientId: string = "00000000-0000-0000-0000-000000000000";
    employeeId: string = "00000000-0000-0000-0000-000000000000";
    serviceId: string = "00000000-0000-0000-0000-000000000000";
}


export class GetTaxBO {
    authorizationId: string;
    employeeId: string;
    clientId: string;
    startDate: string;
    endDate: string;
}
export class functionpermission{
    timesheetcreate:boolean=true;
    timesheetupdate:boolean=true;

    timesheetdelete:boolean=true;
    timesheetmultipleupdate:boolean=true;
}



